import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfoPanelVideoLightboxComponent } from './info-panel-video-lightbox.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [InfoPanelVideoLightboxComponent],
  declarations: [InfoPanelVideoLightboxComponent]
})
export class InfoPanelVideoLightboxModule { }
